import { useRecoilState } from 'recoil'

import { $menuIsOpen } from './selectors'

export const useNavigationMenu = () => {
  const [navigationMenuOpen, setNavigationMenu] = useRecoilState($menuIsOpen)

  return {
    navigationMenuOpen,
    setNavigationMenu,
  }
}
